<mat-sidenav-container>
  <mat-sidenav #projPortfolioDrawer mode="side" autosize class="sidenav-container">
    <app-project-portfolio></app-project-portfolio>
  </mat-sidenav>

  <!-- Drawer button -->
  <div class="drawer-button">
    <button matFab (click)="projPortfolioDrawer.toggle()" matTooltip="Portfolios" matTooltipPosition="right">
      <mat-icon class="large-icon">create_new_folder</mat-icon>
    </button>
  </div>

  <div class="row gx-0 px-5 py-2 align-items-center justify-content-center">
    @if (selectedPortfolio !== undefined) {
      <div class="col gx-0 text-center">
        <h1 class="mb-0">Portfolio: {{ selectedPortfolioName }}</h1>
      </div>
      @if ((myProjectList.length + projectList.length + archiveList.length) > 1) {
        <div class="col-auto me-3 gx-0">
          <button matFab extended aria-label="Portfolio WBS" (click)="openPortfolioInfo()">
            Portfolio WBS
            <mat-icon>view_list</mat-icon>
          </button>
        </div>
      }
    }
    @if (isSiteAdmin) {
      <div class="col-auto gx-0 text-center">
        <input [formControl]="projectUploadControl" type="file" multiple accept=".xer,.mpp" class="d-none" (change)="projectFileUpload($event)" #fileUpload>
        <a matFab extended routerLink="." (click)="fileUpload.click()">
          Upload Project
          <mat-icon>upload</mat-icon>
        </a>
      </div>
    }
  </div>

  <!-- Project Filters -->
  <div class="row gx-0 align-items-center justify-content-center pb-2" [formGroup]="filterForm">
    <div class="col-auto">
      <form>
        <mat-form-field class="dense-1">
          <mat-label>Search Project Name</mat-label>
          <input matInput formControlName="name" type="text" />
          <button matIconButton matSuffix>
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </form>
    </div>
    @if (hasProjectCodes) {
      <div class="col-auto ps-3 text-end">
        <button matFab extended (click)="openProjectCodes()" [matBadge]="projectCodeCount"
          [matBadgeHidden]="!projectCodeCount" class="filter-btn">
          <mat-icon>filter_list</mat-icon>
          Code Filter
        </button>
      </div>
    }
  </div>

  <!-- Iterate over projects -->
  <div class="row gx-0">
    <div appFillHeight class="col gx-0">
      @if (myProjectList.length) {
        <div class="row gx-0 px-5 pt-2 text-center">
          <h2 class="accordion" role="button" data-bs-toggle="collapse" data-bs-target="#collapseMine" aria-expanded="true" aria-controls="collapseMine">My Projects</h2>
        </div>
        <div class="collapse show" id="collapseMine">
          @defer {
            <app-project-list
              [projectList]="myProjectList"
              [isSiteAdmin]="isSiteAdmin"
              [openProjectInfo]="openProjectInfo.bind(this)"
              [toggleProjectLock]="toggleProjectLock.bind(this)"
              [openProjectSettings]="openProjectSettings.bind(this)"
              [deleteProject]="deleteProject.bind(this)"
              [archiveProject]="archiveProject.bind(this)"
              [archiveState]="0"></app-project-list>
          }
        </div>
      }

      @if (projectList.length) {
        <div class="row gx-0 px-5 pt-2 text-center">
          @if (myProjectList.length) {
            <hr>
          }
          <h2 class="accordion collapsed" role="button" data-bs-toggle="collapse" data-bs-target="#collapseOther" aria-expanded="false" aria-controls="collapseOther">Other Projects</h2>
        </div>
        <div class="collapse" [class.show]="!myProjectList.length" id="collapseOther">
          @defer {
            <app-project-list
              [projectList]="projectList"
              [isSiteAdmin]="isSiteAdmin"
              [openProjectInfo]="openProjectInfo.bind(this)"
              [toggleProjectLock]="toggleProjectLock.bind(this)"
              [openProjectSettings]="openProjectSettings.bind(this)"
              [deleteProject]="deleteProject.bind(this)"
              [archiveProject]="archiveProject.bind(this)"
              [archiveState]="0"></app-project-list>
          }
        </div>
      }

      @if (archiveList.length) {
        <div class="row gx-0 px-5 pt-2 text-center">
          @if (myProjectList.length || projectList.length) {
            <hr>
          }
          <h2 class="accordion collapsed" role="button" data-bs-toggle="collapse" data-bs-target="#collapseArchive" aria-expanded="false" aria-controls="collapseArchive">Archived Projects</h2>
        </div>
        <div class="collapse" id="collapseArchive">
          @defer {
            <app-project-list
              [projectList]="archiveList"
              [isSiteAdmin]="isSiteAdmin"
              [openProjectInfo]="openProjectInfo.bind(this)"
              [toggleProjectLock]="toggleProjectLock.bind(this)"
              [openProjectSettings]="openProjectSettings.bind(this)"
              [deleteProject]="deleteProject.bind(this)"
              [archiveProject]="archiveProject.bind(this)"
              [archiveState]="1"></app-project-list>
          }
        </div>
      }
    </div>
  </div>
</mat-sidenav-container>
